import Components from "@components/__Components__/Components";

type Block = {
  component: string;
  uid: string;
  metadata: {
    tags: unknown[];
  };
  fields: Record<string, unknown>;
};

export function RenderComponents(components, inSublayout = false) {
  if (!components) {
    return null;
  }

  return components.map((block: Block, index: number) => {
    const component = {
      component: block.component,
      uid: block.uid,
      tags: block.metadata?.tags?.length > 0 ? block.metadata.tags : null,
      inSublayout,
      ...block.fields,
    };
    return Components(component, block.fields, null, index);
  });
}

export default RenderComponents;
